// src/redux/slices/companySlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async Thunk to Submit Company Details
export const submitCompanyDetails = createAsyncThunk(
  'company/submitCompanyDetails',
  async ({ formData, files }, { rejectWithValue }) => {
    try {
      const submitData = new FormData();

      // Append text fields
      Object.entries(formData).forEach(([key, value]) => {
        submitData.append(key, value);
      });

      // Append files
      if (files.logoFile) submitData.append('companyLogo', files.logoFile);
      if (files.faviconFile) submitData.append('favicon', files.faviconFile);
      if (files.agentFile) submitData.append('agentAppImage', files.agentFile);
      if (files.customerFile) submitData.append('customerAppImage', files.customerFile);

      const apiUrl = `${window.location.protocol}//your-api-endpoint.com/api/company`;
      const response = await axios.post(apiUrl, submitData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const companySlice = createSlice({
  name: 'company',
  initialState: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  reducers: {
    resetCompanyState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitCompanyDetails.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(submitCompanyDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(submitCompanyDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetCompanyState } = companySlice.actions;
export default companySlice.reducer;
